export default "__VITE_ASSET__BRTAnu2g__"